export default __webpack_public_path__ + "static/media/Lucida-Console-Regular.c52c29b6.ttf";